module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"valid_message_length":"(有效字數: {0} 字)"}}')
  delete Component.options._Ctor
}
